// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useRef, useState } from "@wordpress/element";
import { ActivePipelineContext } from "../providers/ActivePipelineContextProvider";
import { ModalContext } from "../providers/ModalContextProvider";
import { PipelinesContext } from "../providers/PipelinesContextProvider";
import { UserContext } from "../providers/UserContextProvider";
var DispatchType;
(function (DispatchType) {
    DispatchType["ACTIVE_PIPELINE"] = "ACTIVE_PIPELINE";
    DispatchType["PIPELINES"] = "PIPELINES";
    DispatchType["USER"] = "USER";
})(DispatchType || (DispatchType = {}));
export const useModal = (closeActionType) => {
    const [modalSaving, setModalSaving] = useState(false);
    const modalContentRef = useRef(null);
    const { modalDispatch } = useContext(ModalContext);
    const { dispatch: activePipelineDispatch } = useContext(ActivePipelineContext);
    const { pipelinesDispatch } = useContext(PipelinesContext);
    const { userDispatch } = useContext(UserContext);
    const closeModal = () => {
        modalDispatch({
            type: closeActionType,
        });
        clearModalContent();
    };
    const clearModalContent = () => {
        if (modalContentRef.current) {
            modalContentRef.current.clearContent();
        }
    };
    const handleSuccess = (type, payload, dispatchType) => {
        let dispatchFunction;
        switch (dispatchType) {
            case DispatchType.PIPELINES: {
                dispatchFunction = pipelinesDispatch;
                break;
            }
            case DispatchType.ACTIVE_PIPELINE: {
                dispatchFunction = activePipelineDispatch;
                break;
            }
            case DispatchType.USER: {
                dispatchFunction = userDispatch;
                break;
            }
            default:
                dispatchFunction = activePipelineDispatch;
                break;
        }
        setModalSaving(false);
        dispatchFunction({
            type,
            payload,
        });
        closeModal();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleError = (error) => {
        setModalSaving(false);
        console.error(error);
    };
    return {
        modalSaving,
        setModalSaving,
        modalContentRef,
        closeModal,
        handleSuccess,
        handleError,
    };
};
export { DispatchType };
